import React, { useEffect, useState } from "react";
import { offlineMediaUrl, cacheMedia } from "../lib/offline";

/**
 * <img> qui fonctionne hors ligne.
 * En ligne : affiche l'URL réseau et met l'image en cache en tache de fond.
 * Si le réseau échoue (hors ligne), bascule sur la version stockée en local.
 * Remplace un <img> classique sans rien changer d'autre (mêmes props).
 */
export default function OfflineImage({ src, ...rest }) {
  const [current, setCurrent] = useState(src);

  useEffect(() => {
    setCurrent(src);
    if (src) cacheMedia(src);
  }, [src]);

  const handleError = async () => {
    if (!src) return;
    const local = await offlineMediaUrl(src);
    if (local && local !== current) setCurrent(local);
  };

  return <img src={current} onError={handleError} {...rest} />;
}
